import React from 'react';

interface SectionHeaderProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
}

export function SectionHeader({ title, description, icon }: SectionHeaderProps) {
  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-2">
        {icon && <div className="text-gray-400">{icon}</div>}
        <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
      </div>
      <p className="text-gray-500 text-sm">{description}</p>
    </div>
  );
}
